/* //eslint-disable */

import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '@/globals'

import Layout2 from '@/layout/Layout2'
import Layout2Flex from '@/layout/Layout2Flex'
import Layout2FlexNoFooter from '@/layout/Layout2FlexNoFooter'
import LayoutBlank from '@/layout/LayoutBlank'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  // Default route
  {
    path: '',
    redirect: '/dashboard'
  },

  // dashboard
  {
    path: '/dashboard',
    component: Layout2FlexNoFooter,
    meta: { requiresAuth: true },
    children: [{
      path: '',
      component: () => import('@/components/Dashboard')
    }]
  },

  // public pages
  {
    path: '/signin',
    component: LayoutBlank,
    children: [{
      path: 'login',
      component: () => import('@/components/signin/AuthenticationLogin')
    }, {
      path: 'email-confirm',
      component: () => import('@/components/signin/AuthenticationEmailConfirm')
    }, {
      path: 'password-reset',
      component: () => import('@/components/signin/AuthenticationPasswordReset')
    }, {
      path: 'register',
      component: () => import('@/components/signin/Register')
    }]
  },

  // pages
  {
    path: '/',
    component: Layout2,
    meta: { requiresAuth: true },
    children: [{
      path: 'workouts',
      component: () => import('@/components/Workouts')
    }, {
      path: 'profile/:id?',
      component: () => import('@/components/Profile')
    }, {
      path: 'followers',
      component: () => import('@/components/Followers')
    }, {
      path: 'trainer-client-requests',
      component: () => import('@/components/TrainerClientRequests')
    }, {
      path: 'account-settings',
      component: () => import('@/components/AccountSettings')
    }]
  },

  // blank page authentication pages
  {
    path: '/',
    component: LayoutBlank,
    meta: { requiresAuth: true },
    children: [{
      path: 'subscription/',
      component: () => import('@/components/Subscription')
    }, {
      path: 'subscription/change',
      component: () => import('@/components/SubscriptionChange')
    }, {
      path: 'billing/:id',
      component: () => import('@/components/Billing')
    }]
  },

  // Flex Layout required pages.
  {
    path: '/',
    component: Layout2Flex,
    meta: { requiresAuth: true },
    children: [{
      path: 'feed',
      component: () => import('@/components/Feed')
    }]
  },

  // Flex Layout required pages NO FOOTER.
  {
    path: '/',
    component: Layout2FlexNoFooter,
    meta: { requiresAuth: true },
    children: [
      /* {
            path: 'workout/:id',
            component: () => import('@/components/Workout')
          }, */
      {
        path: 'workout/:id',
        component: () => import('@/components/WorkoutCreate')
      },
      {
        path: 'workoutgroup/:id',
        component: () => import('@/components/WorkoutGroup')
      }, {
        path: 'clients',
        component: () => import('@/components/Clients')
      },
      {
        path: 'exercises',
        component: () => import('@/components/Exercises')
      }
    ]
  }
]

const router = new Router({
  base: '/',
  mode: 'history',
  routes: ROUTES
})

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(() => splashScreen && splashScreen.parentNode.removeChild(splashScreen), 300)
  }

  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {

    if (localStorage.getItem('user') == null) {
      // clear cookie to force redirect to login page.
      document.cookie = "user_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }

    if (document.cookie.split(';').filter(function(item) {
        return item.trim().indexOf('user_token=') == 0
      }).length) {
      next()
    } else {
      next('/signin/login')
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
